<template>
  <div class="login">
    <!--  @click="fanhui" -->
    <div class="topTitle isFixed">
      <div class="img">
        <img src="../../assets/localImage/return.png" alt />
      </div>
    </div>
    <div class="logo">
      <img src="../../assets/img/logo.png" alt />
    </div>

    <van-tabs @click="onClick">
      <van-tab title="已有帐号"></van-tab>
      <van-tab title="新注册帐号"></van-tab>
    </van-tabs>
    <div class="input">
      <input type="text"  v-model="phone" placeholder="请输入手机号" @blur="onBlur" @focus="onFocus"/>
    </div>

    <div class="input">
      <input type="text" v-model="code" placeholder="请输入验证码"  @blur="onBlur" @focus="onFocus"/>
      <button class="code" @click="getCodeFun" :disabled="disabled">
        <template v-if="sending">
          <p class="color-orange">获取验证码</p>
        </template>
        <template v-else>{{second}}s</template>
      </button>
    </div>

    <div class="input" v-if="register">
      <input type="text" v-model="invitation_code" placeholder="请输入邀请码" @blur="onBlur" @focus="onFocus"/>
    </div>
    <p class="color-orange textL" v-show="isPone">请输入正确的手机号</p>

    <div class="boxBtn">
      <button class="loginBtn" :disabled="btnShow" @click="login()">绑定</button>
    </div>
    

    <van-dialog v-model="show" confirmButtonColor="#F2190B" class="cgdialog" @confirm='queren()'>
      <div class="chenggong">
        <img src="../../assets/img/chenggong.png" alt />
        <P>注册成功</P>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
// import topTitle from "../../components/topTitle.vue";
export default {
  name: "login",
  data() {
    return {
      btnShow: false,
      phone: "",
      isPone: false,
      register: false,
      code: "",
      invitation_code:'',
      sending: true, //是否发送验证码
      disabled: false, //是否禁发验证码
      second: 60, //倒计时间
      show: false,
      result:''
    };
  },
  components: {},
  created(){
    
  },
  methods: {
    onClick(name, title) {
      if(name==0){
        this.register=false;
      }else{
        this.register=true;
      }
    },
    onBlur() {
      setTimeout(function() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }, 300);
    },
    onFocus(e) {
      setTimeout(function() {
        e.target.scrollIntoView({block: "center"});
        // document.body.scrollTop = this.showHeight;
      }, 300);
    },
    //注册成功
    queren(){
      let url = localStorage.getItem('redirect_url').replace('?from=singlemessage', '');
      if(url){
        window.location.href = url;
      }else{
        this.$router.push({ path: "/" });
      }
    },

    login() {
      if (!this.isPoneFun(this.phone)) {
        this.isPone = true;
        Toast("请输入正确的手机号");
        return false;
      }
      if (this.code == "") {
        Toast("请输入验证码");
        return false;
      }
      this.btnShow = true;
      setTimeout(()=>{
        this.btnShow = false;
      },1000)
      if (this.register) {
        let param = {
          password: "e10adc3949ba59abbe56e057f20f883e",
          mobile: this.phone,
          invitation_code: this.invitation_code,
          sms_code: this.code,
          face: this.$route.query.face,
          nickName: this.$route.query.nickname,
          unionid: this.$route.query.unionid,
          uuid: localStorage.getItem('uuid'),
        };
        this.postRequest(`passport/register`, param).then(res => {
          if(res.data.code==1){
            Toast(res.data.message);
          }else{
            localStorage.setItem("token", res.data.data.access_token);
            localStorage.setItem("uid", res.data.data.uid);
            localStorage.setItem("isLogin", true);
            this.show = true
          }
          clearInterval(this.result);

          this.code = '';
          this.sending = true;
          this.second = 60;
          this.disabled = false;
          this.btnShow = false;
        });
      } else {
        let param = {
          sms_code: this.code,
          unionid: this.$route.query.unionid,
          uuid: localStorage.getItem('uuid'),
        };
        this.getRequest(`passport/login/${this.phone}`, param).then(res => {
          localStorage.setItem("loginInfo", JSON.stringify(res.data.data));
          localStorage.setItem("token", res.data.data.access_token);
          localStorage.setItem("uid", res.data.data.uid);
          localStorage.setItem("isLogin", true);
          

          let urls = localStorage.getItem('redirect_url').replace('?from=singlemessage', '');
          if(urls == '' || urls==null){
            this.$router.push({path:'/',});
          }else{
            window.location.href = urls
          }

          this.code = '';
          this.sending = true;
          this.disabled = false;
          this.second = 60;
          this.btnShow = false;
        });
      }
    },
    
    //获取验证码
    getCodeFun() {
      if (!this.sending) return;
      if (this.isPoneFun(this.phone)) {
        if (this.register) {
          this.postRequest(`passport/register/smscode/${this.phone}`).then(
            res => {
              this.sending = false;
              this.disabled = true;
              this.timeDown();
            }
          );
        } else {
          let param = {};
          param.uuid = localStorage.getItem('uuid');
          // localStorage.setItem("uuid", param.uuid);
          param.captcha = "786s";
          this.postRequest(`passport/login/smscode/${this.phone}`, param).then(
            res => {
              if (res.data.code == 1) {
                Toast.fail(res.data.message);
              } else {
                this.sending = false;
                this.disabled = true;
                this.timeDown();
              }
            }
          );
        }
      } else {
        this.isPone = true;
        Toast("请输入正确的手机号");
      }
    },
    timeDown() {
      this.result = setInterval(() => {
        --this.second;
        if (this.second < 0) {
          clearInterval(this.result);
          this.sending = true;
          this.disabled = false;
          this.second = 60;
        }
      }, 1000);
    },
  }
};
</script>


<style scoped lang='less'>
.cgdialog {
  border-radius: 6px;
  width: 540px;
}
/deep/ [class*=van-hairline]::after{
  border: none;
}
.chenggong {
  height: 270px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 78px;
    height: 78px;
    margin-bottom: 30px;
  }
}
.login {
  .topTitle {
    padding: 0 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 89px;

    .img {
      width: 20px;
      height: 36px;
    }
    h2 {
      font-weight: 500;
      font-size: 36px;
      // color: ;
    }
    button {
      font-size: 26px;
      font-weight: 400;
      background-color: #ffffff;
      color: #000000;
    }
  }

  background: #fff;
  height: 100%;
  position: fixed;
  width: 100%;
  .logo {
    width: 205px;
    // height: 177px;
    margin: 50px auto 50px auto;
  }
  .textL {
    width: 662px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .input {
    width: 662px;
    height: 88px;
    line-height: 88px;
    margin: 40px auto;
    position: relative;
    > p.color-orange {
      padding: 15px 25px;
    }
    input {
      width: 662px;
      height: 88px;
      line-height: 88px;
      background-color: #f5f5f5;
      font-size: 28px;
      border-radius: 44px;
      padding-left: 45px;
    }
    .code {
      width: 203px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      color: #8f8f8f;
      border-radius: 44px;
      position: absolute;
      right: 9px;
      bottom: 9px;
      background: #fff;
    }
  }
  .boxBtn {
    width: 100%;
    text-align: center;
  }
  .loginBtn {
    width: 662px;
    height: 88px;
    line-height: 88px;
    background: linear-gradient(
      90deg,
      rgba(242, 20, 12, 1) 0%,
      rgba(254, 119, 0, 1) 99%
    );
    border-radius: 44px;
    text-align: center;
    color: #fff;
    margin: 100px auto 50px auto;
    font-size: 32px;
  }
  .user {
    width: 662px;
    margin: auto;
    color: #5f5f5f;
    text-align: right;
    padding-right: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    p{
      width: 140px;
    }
  }

  .fast {
    width: 662px;
    margin: auto;
    display: flex;
    color: #efefef;
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
    margin-bottom: 50px;
    .line {
      width: 240px;
      height: 2px;
      font-size: 24px;
      background-color: #efefef;
    }
  }
  .weixin {
    text-align: center;
    > div {
      width: 88px;
      height: 88px;
      img {
        width: 100%;
        height: 100%;
      }
      margin: 20px auto;
    }
    p {
      color: #999999;
    }
  }
}
</style>


